import { BoxPlanningApi } from "@modules/boxPlanning/services/boxPlanningApi"
import { ItemBoxSlot } from "@modules/boxSlot/boxSlotTypes"
import { WebService } from "@modules/core/services/webService"
import { observable } from "micro-observables"

export class BoxPlanningService implements WebService {
  private _planningSlots = observable<ItemBoxSlot[]>([])
  readonly planningSlots = this._planningSlots.readOnly()
  private _isLoadingSlots = observable<boolean>(true)
  readonly isLoadingSlots = this._isLoadingSlots.readOnly()

  constructor(private api: BoxPlanningApi) {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async init(): Promise<void> {}

  async onLoggedOut(): Promise<void> {
    this._planningSlots.set([])
  }

  async getPlanningSlots(startDate: string, endDate: string, programId?: string) {
    const result = await this.api.getSlots(startDate, endDate, programId)
    return result
  }

  async updatePlanningSlots(startDate: string, endDate: string, programId?: string) {
    this._isLoadingSlots.set(true)
    const result = await this.getPlanningSlots(startDate, endDate, programId)
    this._planningSlots.set(result)
    this._isLoadingSlots.set(false)
  }
}
